import { styled } from "styled-components";

import MembershipLogo from "../assets/blue-box-oura-logo.svg?react";

export const StyledMembershipLogoIcon = styled(MembershipLogo)`
  width: 53px;
  height: 39px;
`;
